<script setup>
import { Head } from "@inertiajs/inertia-vue3";
import Navbar from "@/Components/Navbar.vue";
import { ref, onMounted, watch } from "vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import HeaderButton from "@/Components/Settings/HeaderButton.vue";

const props = defineProps({
  appointments: Array,
  office: Object,
  workingHours: Object,
  allAppointments: Array,
});

const backUrl = ref("/");
const selectedAppointments = ref(props.appointments);
const patient = ref(
  props.appointments[0].patient ?? props.appointments[0].patient_custom
);
const days = ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."];

function backClicked() {
  //backUrl.value = window.history.back();
  backUrl.value = "/kalender";
}

function openPrint() {
  window.print();
}

function getDateFormatted(date) {
  return (
    days[new Date(date).getDay()] +
    " " +
    new Date(date).toLocaleDateString("de")
  );
}

function getTimeFormatted(date) {
  // get time with leading zeros
  let hours = ("0" + new Date(date).getHours()).slice(-2);
  let minutes = ("0" + new Date(date).getMinutes()).slice(-2);
  return hours + ":" + minutes;
}

function getDuration(date1, date2) {
  let startDate = new Date(date1);
  let endDate = new Date(date2);
  let diffInMilli = Math.abs(startDate - endDate);
  let diffInMin = Math.floor(diffInMilli / 1000 / 60);
  return diffInMin;
}

// onMounted(() => {
//   console.log(props.appointments);
//   console.log(props.allAppointments);
// });

function showAllAppointments(checked) {
  if (checked) {
    selectedAppointments.value = props.allAppointments;

    // order by "date" and "start"
    selectedAppointments.value.sort(function (a, b) {
      if (a.date > b.date) {
        return 1;
      } else if (a.date < b.date) {
        return -1;
      } else {
        if (a.start > b.start) {
          return 1;
        } else if (a.start < b.start) {
          return -1;
        } else {
          return 0;
        }
      }
    });
  } else {
    selectedAppointments.value = props.appointments;
  }
}
</script>

<template>
  <!-- Printview -->
  <div class="printonly">
    <div class="flex mb-8">
      <div class="w-2/3 mx-auto flex flex-col">
        <h3 class="text-2xl">
          {{ props.office.slip_title }}
        </h3>

        <div class="mb-20 text-xs">
          <b>{{ patient.firstname }} {{ patient.lastname }}</b>
        </div>

        <!-- <div v-if="!appointment.series_id" class="mb-5 text-xs">
          <b>{{ getDateFormatted(appointment.start) }}</b
          ><br />
          <b>{{ getTimeFormatted(appointment.start) }} Uhr</b><br />
          <span
            >Dauer: ca.
            {{ getDuration(appointment.start, appointment.end) }}
            Minuten</span
          ><br />
          <span>Behandlung: {{ appointment.type.name }}</span
          ><br />
          <span
            >Behandler:
            {{ props.appointments[0].practitioner.title }}
            {{ props.appointments[0].practitioner.lastname }}</span
          ><br />
        </div> -->

        <div class="mb-8">
          <div v-for="appointment in selectedAppointments" class="mb-5 text-xs">
            <b
              >{{ getDateFormatted(appointment.start) }},
              {{ getTimeFormatted(appointment.start) }}
              Uhr</b
            ><br />
            <span
              >Dauer: ca.
              {{ getDuration(appointment.start, appointment.end) }}
              Minuten</span
            ><br />
            <span>Behandlung: {{ appointment.type.name }}</span
            ><br />
            <span
              >Behandler:
              {{ appointment.practitioner.title }}
              {{ appointment.practitioner.lastname }}</span
            ><br />
          </div>
        </div>
      </div>

      <div class="w-1/3 text-xs">
        <div class="border-l pl-5 pb-8">
          <div v-if="props.office.logo_thumb" class="w-full pr-5 mb-4">
            <img :src="props.office.logo_thumb" alt="Logo" width="100" />
          </div>

          <div class="leading-[0.7rem] text-xs mb-3">
            <div v-if="props.office.name">
              <small>{{ props.office.name }}</small>
            </div>

            <div v-if="props.office.street">
              <small
                >{{ props.office.street }} {{ props.office.street_nr }}</small
              >
            </div>

            <div v-if="props.office.postal_code && props.office.city">
              <small
                >{{ props.office.postal_code }} {{ props.office.city }}</small
              >
            </div>
          </div>

          <div class="leading-[0.7rem] text-xs mb-3">
            <div v-if="props.office.phone" class="mb-1">
              <small>Tel.:{{ props.office.phone }}</small>
            </div>

            <div v-if="props.office.email" class="mb-1">
              <small>E-Mail:{{ props.office.email }}</small>
            </div>

            <div v-if="props.office.website" class="mb-1">
              <small>Web:{{ props.office.website }}</small>
            </div>
          </div>

          <div class="leading-[0.7rem] text-xs mb-3">
            <div class="mb-1"><small>Sprechzeiten:</small></div>
            <table>
              <template v-for="wh in workingHours">
                <tr v-if="wh.open">
                  <td class="pr-2">
                    <small>{{ wh.weekday_short_formatted }}:</small>
                  </td>
                  <td>
                    <small
                      >{{ wh.start.substr(0, wh.start.lastIndexOf(":")) }}-{{
                        wh.end.substr(0, wh.end.lastIndexOf(":"))
                      }}
                      Uhr</small
                    >
                  </td>
                </tr>
                <tr v-if="wh.hasBreak">
                  <td></td>
                  <td>
                    <small
                      >{{
                        wh.start_2.substr(0, wh.start_2.lastIndexOf(":"))
                      }}-{{
                        wh.end_2.substr(0, wh.end_2.lastIndexOf(":"))
                      }}
                      Uhr</small
                    >
                  </td>
                </tr>
              </template>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-auto leading-[1rem] text-xs mb-8">
      {{ props.office.slip_text }}
    </div>

    <hr />
  </div>

  <!-- Webview -->
  <div
    id="theme-wrapper"
    style="background-image: url('/storage/img/auth_bg.jpg')"
    class="bg-cover bg-no-repeat flex bg-oteoBlue-600 min-h-screen noprint"
    :class="'theme-' + $page.props.theme ?? 'spitta'"
  >
    <Head title="Druckansicht" />
    <Navbar class="navbar-sub w-full" />

    <div
      class="bg-white w-full max-w-8xl mx-auto mt-[80px] mb-8 rounded-xl overflow-hidden"
    >
      <header
        class="bg-gray-100 flex justify-between items-center px-12 py-8 rounded-tl-xl rounded-tr-xl relative"
      >
        <div class="py-3">
          <h2 class="text-3xl font-semibold mr-8 mb-1">
            {{ patient.firstname }} {{ patient.lastname }}
          </h2>
          <div
            v-if="selectedAppointments.length == 1"
            class="text-gray-500 opacity-80"
          >
            {{ selectedAppointments[0].type.name }} am
            {{ selectedAppointments[0].date_str }}
          </div>
          <div v-else>&nbsp;</div>
        </div>

        <div class="flex relative">
          <HeaderLink
            @click="backClicked"
            :href="backUrl"
            type="close"
            class="mr-3"
            >Zurück</HeaderLink
          >
          <HeaderButton @click="openPrint()">Drucken</HeaderButton>
        </div>
      </header>
      <!--<pre>{{ appointment.practitioner }}</pre>-->

      <div class="flex flex-col p-12 relative">
        <div
          class="w-[100%] h-100 pb-8"
          v-if="props.allAppointments.length > 1"
        >
          <div class="flex items-center">
            <input
              id="showAllAppointmentsCheckbox"
              @input="showAllAppointments($event.target.checked)"
              type="checkbox"
            />
            <label
              for="showAllAppointmentsCheckbox"
              class="ml-2 font-semibold text-lg"
              >Alle Termine dieser Patientin / dieses Patienten, welche in der
              Zukunft liegen.</label
            >
          </div>
        </div>

        <div class="w-[100%] h-100 pb-8">
          <div class="flex flex-col w-1/2 h-full mx-auto">
            <div class="grow mt-3 mb-16">
              <div
                class="rounded shadow-[5px_5px_15px_5px_rgba(0,0,0,0.2)] h-full p-8"
              >
                <div class="flex flex-col h-full">
                  <div class="flex mb-8">
                    <div class="w-2/3 mx-auto flex flex-col">
                      <h3 class="text-2xl">
                        {{ props.office.slip_title }}
                      </h3>

                      <div class="mb-20 text-xs">
                        <b>{{ patient.firstname }} {{ patient.lastname }}</b>
                      </div>

                      <!-- <div
                        v-if="!appointment.series_id"
                        class="mb-5 mr-5 text-xs"
                      >
                        <b>{{ getDateFormatted(appointment.start) }}</b
                        ><br />
                        <b>{{ getTimeFormatted(appointment.start) }} Uhr</b
                        ><br />
                        <span
                          >Dauer: ca.
                          {{ getDuration(appointment.start, appointment.end) }}
                          Minuten</span
                        ><br />
                        <span class="break-words"
                          >Behandlung: {{ appointment.type.name }}</span
                        ><br />
                        <span
                          >Behandler:
                          {{ appointment.practitioner.title }}
                          {{ appointment.practitioner.lastname }}</span
                        ><br />
                      </div> -->

                      <div class="mb-8">
                        <div
                          v-for="appointment in selectedAppointments"
                          class="mb-5 text-xs"
                        >
                          <b
                            >{{ getDateFormatted(appointment.start) }},
                            {{ getTimeFormatted(appointment.start) }}
                            Uhr</b
                          ><br />
                          <span
                            >Dauer: ca.
                            {{
                              getDuration(appointment.start, appointment.end)
                            }}
                            Minuten</span
                          ><br />
                          <span>Behandlung: {{ appointment.type.name }}</span
                          ><br />
                          <span
                            >Behandler:
                            {{ appointment.practitioner.title }}
                            {{ appointment.practitioner.lastname }}</span
                          ><br />
                        </div>
                      </div>
                    </div>

                    <div class="w-1/3 text-xs">
                      <div class="border-l pl-5 pb-8">
                        <div
                          v-if="props.office.logo_thumb"
                          class="w-full pr-5 mb-4"
                        >
                          <img
                            :src="props.office.logo_thumb"
                            alt="Logo"
                            width="100"
                          />
                        </div>

                        <div class="leading-[0.7rem] text-xs mb-3">
                          <div v-if="props.office.name">
                            <small>{{ props.office.name }}</small>
                          </div>

                          <div v-if="props.office.street">
                            <small
                              >{{ props.office.street }}
                              {{ props.office.street_nr }}</small
                            >
                          </div>

                          <div
                            v-if="props.office.postal_code && props.office.city"
                          >
                            <small
                              >{{ props.office.postal_code }}
                              {{ props.office.city }}</small
                            >
                          </div>
                        </div>

                        <div class="leading-[0.7rem] text-xs mb-3">
                          <div v-if="props.office.phone" class="mb-1">
                            <small>Tel.:{{ props.office.phone }}</small>
                          </div>

                          <div v-if="props.office.email" class="mb-1">
                            <small>E-Mail:{{ props.office.email }}</small>
                          </div>

                          <div v-if="props.office.website" class="mb-1">
                            <small>Web:{{ props.office.website }}</small>
                          </div>

                          <div class="leading-[0.7rem] text-xs mb-3">
                            <div class="mb-1"><small>Sprechzeiten:</small></div>
                            <table>
                              <template v-for="wh in workingHours">
                                <tr v-if="wh.open">
                                  <td class="pr-2">
                                    <small
                                      >{{ wh.weekday_short_formatted }}:</small
                                    >
                                  </td>
                                  <td>
                                    <small
                                      >{{
                                        wh.start.substr(
                                          0,
                                          wh.start.lastIndexOf(":")
                                        )
                                      }}-{{
                                        wh.end.substr(
                                          0,
                                          wh.end.lastIndexOf(":")
                                        )
                                      }}
                                      Uhr</small
                                    >
                                  </td>
                                </tr>
                                <tr v-if="wh.hasBreak">
                                  <td></td>
                                  <td>
                                    <small
                                      >{{
                                        wh.start_2.substr(
                                          0,
                                          wh.start_2.lastIndexOf(":")
                                        )
                                      }}-{{
                                        wh.end_2.substr(
                                          0,
                                          wh.end_2.lastIndexOf(":")
                                        )
                                      }}
                                      Uhr</small
                                    >
                                  </td>
                                </tr>
                              </template>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-auto leading-[1rem] text-xs">
                    {{ props.office.slip_text }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
/* print view properties */
.printonly {
  display: none;
}

@media print {
  @page {
    size: portrait;
    margin: 0;
  }
  body {
    margin: 1.5cm;
  }
  .noprint,
  .noprint * {
    display: none;
  }
  .printonly {
    display: block;
  }
}
</style>
